module.exports = __webpack_public_path__ + "static/media/layoutVertical.c2ae3734.svg";